import { VulnerabilitiesAppBaseDataProvider } from './VulnerabilitiesAppBaseDataProvider';
import { VulnerabilitiesAppWebComponentSchema } from '../types';

export class VulnerabilitiesAppNirvanaDataProvider extends VulnerabilitiesAppBaseDataProvider {
  async getDataForView(): Promise<VulnerabilitiesAppWebComponentSchema> {
    return {} as unknown as VulnerabilitiesAppWebComponentSchema;
  }
}
